import { atom } from 'jotai';

import type { WorkflowSelection } from '../../../contracts/workflows/components/workflowSelection';

/**
 * One-shot request to open a specific workflows selection from outside the
 * split view (e.g. a past run clicked in the chat sidebar). ``WorkflowsSplitView``
 * consumes it on mount / when it changes and clears it back to ``null``.
 */
export const pendingWorkflowSelectionAtom = atom<WorkflowSelection | null>(null);

/**
 * How the pending selection should land: 'sidebar' renders the routine
 * standalone (no Explore list); 'routines' keeps the split so the routine
 * opens in the right-hand pane (e.g. Work-home "Make it your own"). One-shot,
 * reset to 'sidebar' when the pending selection is consumed.
 */
export const pendingWorkflowSelectionOriginAtom = atom<'sidebar' | 'routines'>('sidebar');

/**
 * Mirror of the split view's current selection so the sidebar can highlight
 * the active routine / run. Cleared when the split view unmounts.
 */
export const currentWorkflowSelectionAtom = atom<WorkflowSelection | null>(null);

/**
 * One-shot request to reset the split view back to the browse surface (clear
 * any open routine). A plain ``null`` on {@link pendingWorkflowSelectionAtom}
 * can't express this — the split view treats null as "nothing pending" — so
 * clicking "Routines" while a routine is already open bumps this nonce instead.
 * ``WorkflowsSplitView`` watches it and clears its selection.
 */
export const workflowBrowseResetAtom = atom(0);
